// extracted by mini-css-extract-plugin
export var actions = "_s8-4";
export var item = "_s8-1";
export var price = "_s8-3";
export var quantity = "_s8-2";
export var table = "_s8-0";